import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";

export class memberGoldenYourRedeemedVouchers {
	private memberBase:any = new memberPortal();

	initTables() {
		let _self = this;
		let goldenVoucherTable = $('.miles-golden-your-redeemed-vouchers table');

		_self.memberBase.initTables(goldenVoucherTable, true);
	}

	resendEmailLinks() {
		let _self = this;
		$(".email-request .link").on('click',function(){
			console.log("Voucher Id is ::"+$(this).attr("data-voucherid"));
			var data={'awardId':$(this).attr("data-voucherid")};
	    	$.ajax({
				type : 'POST',
				url : '/bin/services/new/resendvoucher',
				data : data,
				success : function(msg:any) {
					_self.redirectUser(msg);
					if (msg === "OK") {
						alert("Your voucher is sent to your registered Email.");
					} else {
						alert("There is some error while sending the voucher to your email.");
					}
					console.log("This is the message ::"+msg);
				}
			});
		});
	}

	redirectUser(msg:any):void {
		if(msg.indexOf("timeout") > -1) {
			msg = msg.replace("timeout-","");
			window.location.href = msg;
		}
	}
}

let scope:Element = document.querySelector('.miles-golden-your-redeemed-vouchers table');

if (scope) {
	try {
	let membergyrv = new memberGoldenYourRedeemedVouchers();
	membergyrv.initTables();
	membergyrv.resendEmailLinks();	
	} catch(e) {console.error(e);}
}
